export const callerTypes = {
    CONTACT: "Contact",
    USER: "User"
};
